//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TreeVue',
  props: {
    parentTree: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    frameId: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    types: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      drawerConfig: {},
      filterText: '',
      treeData: [],
      isShowEdit: '',
      multipleSelection: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      focusShow: true,
      frame_id: 0,
      personConfig: {},
      parentId: [],
      topId: '',
      // 顶级id
      activeValue: '' // 记录当前那个框展开
    };
  },
  watch: {
    parentTree: {
      handler: function handler(nVal) {
        var _this = this;
        this.$nextTick(function () {
          if (!_this.isShowEdit && nVal.length) {
            var value = _this.treeData[0];
            _this.$refs.tree.setCurrentKey(nVal[0].value);
          }
          _this.topId = nVal.length ? nVal[0].value : '';
        });
      },
      deep: true
    },
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    // 编辑窗口显示
    handleShow: function handleShow(value) {
      this.activeValue = value;
    },
    // 编辑窗口隐藏
    handleHide: function handleHide() {
      this.activeValue = '';
    },
    // tree节点点击
    handleClick: function handleClick(node) {
      if (node == 1) {
        this.focusShow = true;
        this.frame_id = 0;
        this.isShowEdit = '';
        this.$emit('frameId', 0);
        this.$refs.tree.setCurrentKey();
      } else {
        this.focusShow = false;
        if (this.activeValue) {
          this.$refs["pop-".concat(this.activeValue)].doClose();
        }
        this.frame_id = node.value;
        this.isShowEdit = '';
        this.$emit('frameId', node.value);
      }
    },
    // 显示tree编辑
    showTreeEdit: function showTreeEdit(node, data) {
      this.isShowEdit = data.value;
    },
    // tree搜索过滤
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  }
};